<template>
  <vx-card title="Editando categoría">
    <div class="px-5 text-center" v-if="category">
      <div class="vx-row">
        <div class="vx-col w-full mb-5">
          <vs-input
            class="w-full"
            label-placeholder="Nombre"
            v-model="category.titleCategory"
          />
        </div>

        <div class="vx-col w-full">
          <vs-textarea label="Descripción" v-model="category.description" />
        </div>

        <div class="vx-col w-full">
          <vs-input
            class="w-full"
            label-placeholder="Palabras clave"
            v-model="category.keywords"
          />
        </div>

        <div class="vx-col sm:w-1/2 w-full mb-3 text-center">
          <vx-card>
            <div
              class="d-flex flex-column justify-content-center align-items-center"
            >
              <img
                :src="category.image ? category.image.url : ''"
                alt=""
                class="img-category-edit mb-1"
                v-if="category.image"
              />

              <div class="mt-5">
                <vs-button
                  color="success"
                  type="border"
                  size="small"
                  @click="setShowModalImages('destacada')"
                  >Destacada</vs-button
                >
              </div>
            </div>
          </vx-card>
        </div>

        <div class="vx-col sm:w-1/2 w-full text-center">
          <vx-card class="text-center">
            <div
              class="d-flex flex-column justify-content-center align-items-center"
            >
              <img
                :src="category.open_graph ? category.open_graph.url : ''"
                alt=""
                class="img-category-edit mb-1"
                v-if="category.open_graph"
              />

              <div class="mt-5">
                <vs-button
                  color="success"
                  type="border"
                  size="small"
                  @click="setShowModalImages('open_graph')"
                  >Redes sociales</vs-button
                >
              </div>
            </div>
          </vx-card>
        </div>

        <div class="vx-col w-full mb-5">
          <vs-button
            class="mt-5"
            color="danger"
            type="filled"
            :disabled="!validate || loading"
            @click="update()"
            >{{ loading ? "Actualizando" : "Actualizar" }}</vs-button
          >
        </div>
      </div>
    </div>

    <modal-images @imagenSeleccionada="asignarImagen($event)"></modal-images>
  </vx-card>
</template>

<script>
import GetSlugCategorias from "@/apollo/queries/blog/categorias/GetSlugCategorias.gql";
import UpdateCategoriaBlog from "@/apollo/mutations/blog/categorias/UpdateCategoriaBlog.gql"

import ModalImages from "@/components/app/imagenes/ModalImages";

export default {
  data() {
    return {
      slug: this.$route.params.slug,
      loading: false,
      tipoImagen: null,
      category: null,
    };
  },
  mounted() {
    this.getInfo();
  },
  components: {
    ModalImages,
  },
  methods: {
    getInfo() {
      this.loading = true;

      this.$apollo
        .query({
          query: GetSlugCategorias,
          variables: {
            slug: this.slug,
          },
        })
        .then((response) => {
          this.category = response.data.GetSlugCategorias;

          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    setShowModalImages(type) {
      this.tipoImagen = type;

      this.$store.dispatch("updateModalImagesStatus", true);
    },
    asignarImagen(data) {
      if (this.tipoImagen === "destacada") {
        this.category.image = data;
      } else if (this.tipoImagen === "open_graph") {
        this.category.open_graph = data;
      }
    },
    update() {
      this.loading = true;

      let input = {
        id: this.category.id,
        titleCategory: this.category.titleCategory,
        image: this.category.image.id,
        open_graph: this.category.open_graph ? this.category.open_graph.id : "",
        description: this.category.description,
        keywords: this.category.keywords
      };

      this.$apollo
        .mutate({
          mutation: UpdateCategoriaBlog,
          variables: {
            input,
          },
        })
        .then(() => {
          this.loading = false;

          this.$router.push({ name: "categorias-blog" });

          this.isSidebarActiveLocal = false;

          this.$vs.notify({
            title: "Categoría actualizada",
            color: "success",
            position: "top-right",
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
  computed: {
    validate: function () {
      let status = false;

      if (this.category.titleCategory && this.category.image) {
        status = true;
      }

      return status;
    },
  },
};
</script>

<style lang="scss">
.img-category-edit {
  width: 220px;
}

.d-flex {
  display: flex;
}

.flex-column {
  flex-direction: column;
}

.justify-content-center {
  justify-content: center;
}

.align-items-center {
  align-items: center;
}
</style>